import React from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { IconButton, Drawer, Typography, Divider, Box } from '@mui/material'

import CreateTime from './CreateTimeV2'
import HistoricalUsageLogTable from './HistoricalUsageLogTable'
import { useOrgName } from 'src/hooks/useOrgName'

interface ExternalAircraftTimeModalProps {
  open: boolean
  onClose: () => void
  aircraft: {
    id: string
    tailNumber: string
    model: string
    components: Array<{
      id: string
      name: string
      partNumber?: string
      serialNumber?: string
    }>
  }
  onSuccess?: (usageLogId: string) => void
}

const ExternalAircraftTimeModal: React.FC<ExternalAircraftTimeModalProps> = ({
  open,
  onClose,
  aircraft,
  onSuccess,
}) => {
  const orgSlug = useOrgName()

  const handleApplyHistorical = (usageLogId: string) => {
    // When applying an existing usage log, we just pass the ID directly
    // No need to create a new one
    onSuccess?.(usageLogId)
  }

  const handleCreateNew = (usageLogId: string) => {
    // When creating a new usage log, we pass the ID
    onSuccess?.(usageLogId)
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      aria-labelledby="external-aircraft-time-modal-title"
      aria-describedby="external-aircraft-time-modal-description"
      disablePortal
      sx={{ zIndex: 1300 }}
      PaperProps={{
        className: 'min-w-[60%]',
      }}
    >
      <div className="flex items-center justify-between p-2">
        <Typography variant="h6" id="external-aircraft-time-modal-title">
          Update Aircraft Times
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />

      <Box
        id="external-aircraft-time-modal-description"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 120px)',
          overflow: 'auto',
        }}
      >
        {/* Create Time Form - Top Section */}
        <Box sx={{ flex: '0 0 auto' }}>
          <CreateTime aircraft={aircraft} onSuccess={handleCreateNew} />
        </Box>

        {/* Divider */}
        <Divider />

        {/* Historical Usage Log Table - Bottom Section */}
        <Box sx={{ flex: '1 1 auto' }}>
          <HistoricalUsageLogTable
            orgSlug={orgSlug}
            externalAircraftId={aircraft.id}
            onApply={handleApplyHistorical}
          />
        </Box>
      </Box>
    </Drawer>
  )
}

export default ExternalAircraftTimeModal
